
  <div id="wrapper">
      <!-- header -->

      <!-- page-title -->
      <div class="tf-page-title">
          <div class="container-full">
              <div class="heading text-center">Mon Compte</div>
          </div>
      </div>
      <!-- /page-title -->

      <!-- page-cart -->
      <section class="flat-spacing-11">
          <div class="container">
              <div class="row">
                  <div class="col-lg-3">
                      <div class="wrap-sidebar-account">
                          <ul class="my-account-nav">
                              <li><a href="/account" class="my-account-nav-item ">Tableau de bord</a></li>
                              <li><a href="/accountorders" class="my-account-nav-item">Commandes</a></li>
                              <li><span class="my-account-nav-item active">Détails du compte</span></li>
                              <li><a (click)="logout()" class="my-account-nav-item">Déconnexion</a></li>
                          </ul>
                      </div>

                  </div>
                  <div class="col-lg-9">
                    <div class="my-account-content account-edit">
                      <div>
                        <form id="form-password-change" (ngSubmit)="saveChanges()">
                          <div class="tf-field style-1 mb_15">
                            <input class="tf-field-input tf-input" placeholder=" " type="text" [(ngModel)]="userInfo.prenom" name="firstName">
                            <label class="tf-field-label fw-4 text_black-2">Prénom</label>
                          </div>
                          <div class="tf-field style-1 mb_15">
                            <input class="tf-field-input tf-input" placeholder=" " type="text" [(ngModel)]="userInfo.nom" name="lastName">
                            <label class="tf-field-label fw-4 text_black-2">Nom</label>
                          </div>
                          <div class="tf-field style-1 mb_15">
                            <input class="tf-field-input tf-input" placeholder=" " type="email" [(ngModel)]="userInfo.email" name="email">
                            <label class="tf-field-label fw-4 text_black-2">Email</label>
                          </div>
                          <div class="tf-field style-1 mb_15">
                            <input class="tf-field-input tf-input" placeholder=" " type="email" [(ngModel)]="userInfo.address" name="address">
                            <label class="tf-field-label fw-4 text_black-2">Adresse</label>
                          </div>
                          <div class="tf-field style-1 mb_15">
                            <input class="tf-field-input tf-input" placeholder=" " type="email" [(ngModel)]="userInfo.telephone" name="email">
                            <label class="tf-field-label fw-4 text_black-2">Telephone</label>
                          </div>
                          <div class="tf-field style-1 mb_15">
                            <input class="tf-field-input tf-input" placeholder=" " type="email" [(ngModel)]="userInfo.date_naissance" name="email">
                            <label class="tf-field-label fw-4 text_black-2">Date de naissance</label>
                          </div>


                          <h6 class="mb_20">Changement de mot de passe</h6>
                          <div class="tf-field style-1 mb_30">
                            <input class="tf-field-input tf-input" placeholder=" " type="password" [(ngModel)]="userInfo.password" name="currentPassword">
                            <label class="tf-field-label fw-4 text_black-2">Mot de passe actuel</label>
                          </div>
                          <div class="tf-field style-1 mb_30">
                            <input class="tf-field-input tf-input" placeholder=" " type="password" [(ngModel)]="userInfo.newpassword" name="newPassword">
                            <label class="tf-field-label fw-4 text_black-2">Nouveau mot de passe</label>
                          </div>
                          <div class="tf-field style-1 mb_30">
                            <input class="tf-field-input tf-input" placeholder=" " type="password" [(ngModel)]="userInfo.confirmPassword" name="confirmPassword">
                            <label class="tf-field-label fw-4 text_black-2">Confirmer le mot de passe</label>
                          </div>

                          <div class="mb_20">
                            <button type="submit" class="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center">Enregistrer les modifications</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

              </div>
          </div>
      </section>
      <!-- page-cart -->

      <div class="btn-sidebar-account">
          <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas"><i
                  class="icon icon-sidebar-2"></i></button>
      </div>



  </div>

  <!-- gotop -->
  <button id="goTop">
      <span class="border-progress"></span>
      <span class="icon icon-arrow-up"></span>
  </button>
  <!-- /gotop -->

  <!-- sidebar account-->
  <div class="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
      <div class="canvas-wrapper">
          <header class="canvas-header">
              <span class="title">Menu du compte</span>
              <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
          </header>
          <div class="canvas-body sidebar-mobile-append">

          </div>

      </div>
  </div>
  <!-- End sidebar account -->



  <!-- toolbar-bottom -->
 <div class="tf-toolbar-bottom type-1150">
      <div class="toolbar-item">
          <a href="#toolbarShopmb" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
              <div class="toolbar-icon">
                  <i class="icon-shop"></i>
              </div>
              <div class="toolbar-label">Shop</div>
          </a>
      </div>

      <div class="toolbar-item">
          <a href="#canvasSearch" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
              <div class="toolbar-icon">
                  <i class="icon-search"></i>
              </div>
              <div class="toolbar-label">Recherche</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a  (click)="goToAccount($event)" data-bs-toggle="modal">
              <div class="toolbar-icon">
                  <i class="icon-account"></i>
              </div>
              <div class="toolbar-label">Compte</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="/wishlist">
              <div class="toolbar-icon">
                  <i class="icon-heart"></i>
                  <div class="toolbar-count">{{ wishlistCount }}</div>
              </div>
              <div class="toolbar-label">Favoris</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="#shoppingCart" data-bs-toggle="modal">
              <div class="toolbar-icon">
                  <i class="icon-bag"></i>
                  <div class="toolbar-count">{{ cartCount }}</div>
              </div>
              <div class="toolbar-label">Panier</div>
          </a>
      </div>
  </div>
  <!-- /toolbar-bottom -->



